/**
 * @file Hook: useErrorHandler
 * @description Bridges async/effect/event-handler errors into React's error boundary system.
 * Returns a function that, when called with an error, triggers a re-render that throws
 * the error during rendering — allowing the nearest ErrorBoundary to catch it.
 *
 * Usage:
 *   const throwError = useErrorHandler();
 *
 *   useEffect(() => {
 *     fetchData().catch(throwError);
 *   }, []);
 */

import { useState } from 'react';

const useErrorHandler = (): ((error: unknown) => void) => {
  const [error, setError] = useState<unknown>(null);
  if (error) throw error;
  return setError;
};

export default useErrorHandler;
